import React from 'react';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Box, IconButton, Popover, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { CustomCalendar } from 'src/components/Dialogs/BookingsDialog/BookingsDialog';
import { CalendarSidebarIcon } from 'src/Icons';

import { Button } from '../../Calendar/components/Header/components';

interface TimeSheetHeaderProps {
  date: any;
  onClickBackward: () => void;
  onClickForward: () => void;
  onDateChanged: (newDate: any) => void;
}

export const TimeSheetHeader = ({
  date,
  onDateChanged,
  onClickBackward,
  onClickForward,
}: TimeSheetHeaderProps) => {

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  // @ts-ignore
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      paddingBottom: '14px',
      borderBottom: '1px solid #F3F3F3',
      margin: '35px 16px 0px',
    }}>
      <IconButton
        onClick={handleClick}
        sx={{
          width: '46px',
          height: '46px',
          borderRadius: '6px',
          border: '1px solid #D6D6DB',
          color: '#1F1F1F',
          fontSize: '16px',
          marginRight: '15px',
        }}
        disableRipple>
        <CalendarSidebarIcon />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <CustomCalendar
              dayOfWeekFormatter={(nameofday) => nameofday}
              showDaysOutsideCurrentMonth
              value={date}
              onChange={onDateChanged}
              fixedWeekNumber={6}
              sx={{
                // marginTop: "24px",
              }}
            />
          </LocalizationProvider>
        </Box>
      </Popover>


      <Box sx={{
        minWidth: '435px',
        width: '435px',
      }}>
        <Typography sx={{
          color: '#1F1F1F',
          fontWeight: '600',
          fontSize: '36px',
          textAlign: 'center',
          lineHeight: 1,
        }}>
          {date.format('ddd, D MMMM YYYY')}
        </Typography>
      </Box>
      <Box sx={{
        marginLeft: '14px',
      }}>
        <Button
          Icon={ChevronLeft}
          onClick={onClickBackward}
          sx={{marginRight: '4px'}}
        />
        <Button
          Icon={ChevronRight}
          onClick={onClickForward}
        />
      </Box>
    </Box>
  );
}
